var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThetaHacks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 1175 2675",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b8d3d1}.cls-2{fill:#ce7b91}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.8,1149.2c-3.85,62-5.8,125-5.8,188.3,0,323,49.8,625.4,140.2,851.4C393.1,2383.7,494.9,2500,587.5,2500c125.45,0,286.55-221.2,366.25-645.2l169.5,45.45c-39,201.1-98.5,374.65-173.85,506.25C822.3,2628.4,682.45,2675,587.5,2675c-171.75,0-326.2-149.55-434.8-421.1C54.25,2007.7,0,1682.25,0,1337.5c0-104.6,5-208.4,14.9-308.6L25.05,926.3,849.1,1147.1v181.2Z",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.9,1346.7v181.2L1150,1748.7l10.15-102.6c9.9-100.15,14.9-204,14.9-308.6,0-344.75-54.25-670.2-152.7-916.4C913.65,149.55,759.25,0,587.5,0,492.55,0,352.7,46.6,225.6,268.5,150.25,400.1,90.75,573.65,51.75,774.8l169.4,45.4C301,396.2,462.05,175,587.5,175c92.6,0,194.4,116.3,272.3,311.1,90.4,226,140.2,528.4,140.2,851.4,0,63.35-2,126.35-5.8,188.3Z",
    className: "cls-2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThetaHacks);
export default __webpack_public_path__ + "static/media/ThetaHacks.e64646b0e9e2a0872a141727b455b2d8.svg";
export { ForwardRef as ReactComponent };